import { render, staticRenderFns } from "./ItemTimelineAssignment.vue?vue&type=template&id=9224261e&scoped=true&"
import script from "./ItemTimelineAssignment.vue?vue&type=script&lang=js&"
export * from "./ItemTimelineAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9224261e",
  null
  
)

export default component.exports